<script setup lang="ts">
import "./MSpinnerBall.scss";
import { computed } from "vue";
import type { MSpinnerBallProps } from "./MSpinnerBall.props";
import { mSpinnerBallDefaults } from "./MSpinnerBall.props";

const props = withDefaults(defineProps<MSpinnerBallProps>(), mSpinnerBallDefaults);

const SIZE_KEYWORDS: Record<string, string> = {
  xs: "18px",
  sm: "24px",
  md: "32px",
  lg: "38px",
  xl: "46px",
};

const cSize = computed(() => {
  const s = props.size;
  if (typeof s === "number") return `${s}px`;
  if (typeof s === "string" && s in SIZE_KEYWORDS) return SIZE_KEYWORDS[s];
  return s as string;
});
</script>
<template>
  <svg
    class="m-spinner-ball"
    :width="cSize"
    :height="cSize"
    viewBox="0 0 57 57"
    xmlns="http://www.w3.org/2000/svg"
    role="status"
    aria-label="Loading"
  >
    <g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd">
      <circle cx="5" cy="50" r="5">
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          values="50;5;50;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          begin="0s"
          dur="2.2s"
          values="5;27;49;5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="27" cy="5" r="5">
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          from="5"
          to="5"
          values="5;50;50;5"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          begin="0s"
          dur="2.2s"
          from="27"
          to="27"
          values="27;49;5;27"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="49" cy="50" r="5">
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          values="50;50;5;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          from="49"
          to="49"
          begin="0s"
          dur="2.2s"
          values="49;5;27;49"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </svg>
</template>
